import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getTermsAndCondition, setActiveStep } from "../../new-booking-form.slice";
import TAConditionProvidentLandProjects from "./TAConditionProvidentLandProjects";
import TAConditionPuravankaraLandProjects from "./TAConditionPuravankaraLandProjects";
import TermsAndConditionFirst from "./TermsAndConditionFirst";
import Loader from "../../../../components/Loader";
import { BOOKING_AS } from "../../../../config/constant";

const TermsAndCondition = ({ isPreview }) => {
  const [termsAndCondition, setTermsAndCondition] = useState(null);
  const { applicantData, activeStep, isLoading, enquiryDetails } = useSelector(
    (state) => state?.newBookingForm
  );

  const dispatch = useDispatch();
  
  useEffect(() => {
    if(enquiryDetails?.data?.ProjectName && enquiryDetails?.data?.projectBrandName) {
      dispatch(getTermsAndCondition(`/${enquiryDetails?.data?.ProjectName}`)
      )
        .unwrap()
        .then((data) => {
          setTermsAndCondition(data || {});
        })
        .catch(() => {
          setTermsAndCondition(null);
        });
    }
  }, [enquiryDetails]);

  useEffect(() => {
    if (applicantData?.noOfApplicants >= 1 && !applicantData?.applicant1) {
      if (applicantData?.bookingAs === BOOKING_AS.INDIVIDUAL) {
        dispatch(setActiveStep(0))
      } else {
        dispatch(setActiveStep(2))
      }
    }
    if (applicantData?.noOfApplicants >= 2 && !applicantData?.applicant2) {
      if (applicantData?.bookingAs === BOOKING_AS.INDIVIDUAL) {
        dispatch(setActiveStep(1))
      } else {
        dispatch(setActiveStep(3))
      }
    }
    if (applicantData?.noOfApplicants >= 3 && !applicantData?.applicant3) {
      if (applicantData?.bookingAs === BOOKING_AS.INDIVIDUAL) {
        dispatch(setActiveStep(2))
      } else {
        dispatch(setActiveStep(4))
      }
    }
    if (applicantData?.noOfApplicants >= 4 && !applicantData?.applicant4) {
      if (applicantData?.bookingAs === BOOKING_AS.INDIVIDUAL) {
        dispatch(setActiveStep(3))
      } else {
        dispatch(setActiveStep(5))
      }
    }
  }, [applicantData])

  const handlePrevious = () => {
    dispatch(setActiveStep(activeStep - 1));
  };

  const showTermsCondtionComp = () => {
    if (
      termsAndCondition &&
      termsAndCondition?.termsConditions === "puravankara_terms"
    ) {
      return (
        <TermsAndConditionFirst
          isPreview={isPreview}
          handlePrevious={handlePrevious}
          primarySource={enquiryDetails?.data?.primarySource !== null && enquiryDetails?.data?.primarySource?.length > 0 ? enquiryDetails?.data?.primarySource : null}
        />
      );
    } else if (
      termsAndCondition &&
      termsAndCondition?.termsConditions === "puravankara_land_terms"
    ) {
      return (
        <TAConditionPuravankaraLandProjects
          isPreview={isPreview}
          handlePrevious={handlePrevious}
          primarySource={enquiryDetails?.data?.primarySource !== null && enquiryDetails?.data?.primarySource?.length > 0 ? enquiryDetails?.data?.primarySource : null}
          projectName={enquiryDetails?.data?.ProjectName}
          />
        );
      } else if (
        termsAndCondition &&
        (termsAndCondition?.termsConditions === "provident_land_terms" ||
          termsAndCondition?.termsConditions === "provident_terms")
      ) {
        return (
          <TAConditionProvidentLandProjects
          isPreview={isPreview}
          handlePrevious={handlePrevious}
          primarySource={enquiryDetails?.data?.primarySource !== null && enquiryDetails?.data?.primarySource?.length > 0 ? enquiryDetails?.data?.primarySource : null}
          projectName={enquiryDetails?.data?.ProjectName}
        />
      );
    }
  };

  return (
    <>
      {isLoading && <Loader isLoading={isLoading} />}
      {termsAndCondition && showTermsCondtionComp()}
    </>
  );
};

export default TermsAndCondition;